module.exports = __webpack_public_path__ + "static/media/Mentorship-1.73a7afae.jpg";